import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Row, Button, Table, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import TablePagination from 'components/common/TablePagination';
import { stateListAPI } from 'actions/StateMaster/stateMasterAction';
import { countryListAPI } from 'actions/CountryMaster/countryMasterAction';
import { customerDetailAction, generateCustomerInquiryPdfAPI, getCustomerInquiryListAPI } from 'actions/CustomerInquiry/customerInquiryAction';
import loader from '../../assets/img/loader.svg'

export const CustomerInquiryListDetails = () => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const [perPage, setPerPage] = useState(15);
	const [customerInquiryList, setCustomerInquiryList] = useState([]);
	const [pageNumber, setPageNumber] = useState(1);
	const [stateList, setStateList] = useState([]);
	const [countryList, setCountryList] = useState([]);
	const [pageSize, setPageSize] = useState(15);
	const [subscriptionCount, setSubscriptionCount] = useState(0);

	let pageCount = Math.ceil(subscriptionCount / pageSize);
	const isPreviousDisabled = pageNumber === 1;
	const isNextDisabled = pageNumber === pageCount;
	let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
	const headers = {
		Authorization: `Bearer ${JSON.parse(token).value}`
	};
	const customerInquiryReducer = useSelector(
		state => state.rootReducer.customerInquiryReducer
	);
	var customerInquiryData = customerInquiryReducer.customerInquiryData

	useEffect(() => {
		getCountries();
		fetchSubscriptionList(pageNumber, pageSize)
	}, [])

		useEffect(() => {
				  setTimeout(() => {
					setIsLoading(false);
				  }, 1000);
		}, [isLoading])
	const fetchSubscriptionList = async (newPageNumber, newPageSize) => {
		let requestData = {
			EncryptedAdvocateCode: localStorage.getItem("EncryptedAdvocateCode"),
			PageNumber: newPageNumber ? newPageNumber : pageNumber,
			PageSize: newPageSize ? newPageSize : pageSize,
			regType: customerInquiryData.regType ? customerInquiryData.regType : "",
			countryCode: customerInquiryData.countryCode ? customerInquiryData.countryCode : "",
			stateCode: customerInquiryData.stateCode ? customerInquiryData.stateCode : "",
			isPDFGenerate: false
		}
		setIsLoading(true);

		await dispatch(
			getCustomerInquiryListAPI(
				requestData,
				res => {
					if (res.data.data.customerInqList.length > 0) {
						setIsLoading(false);
						setCustomerInquiryList(res.data.data.customerInqList)
						setSubscriptionCount(res.data.data.totalCount)
					} else {
						setIsLoading(false);
						setCustomerInquiryList([])
						setTimeout(function () {
							$('#no-subscription-message').html('No records found!');
						}, 100)
					}
				},
				err => {
					setIsLoading(false);
					setCustomerInquiryList([])
					setTimeout(function () {
						$('#no-subscription-message').html('No records found!');
					}, 100)
					console.log(err?.data.message);
				},
				headers
			)
		);
	}

	const GeneratePDFCustomerInquiry = async (newPageNumber, newPageSize) => {
		let requestData = {
			EncryptedAdvocateCode: localStorage.getItem("EncryptedAdvocateCode"),
			PageNumber: newPageNumber ? newPageNumber : pageNumber,
			PageSize: newPageSize ? newPageSize : pageSize,
			regType: customerInquiryData.regType ? customerInquiryData.regType : "",
			countryCode: customerInquiryData.countryCode ? customerInquiryData.countryCode : "",
			stateCode: customerInquiryData.stateCode ? customerInquiryData.stateCode : "",
			isPDFGenerate: true
		}
				setIsLoading(true);
		await dispatch(
			generateCustomerInquiryPdfAPI(
				requestData,
				(res) => {
					setIsLoading(false);
					console.log(res);
				},
				(err) => {
								setIsLoading(false);
					console.error("Error occurred while generating PDF:", err?.message || err);
				},
				headers
			)
		);
	}

	const getCountries = async (page, size = perPage) => {
		const data = {
			pageNumber: page,
			pageSize: size,
			SearchText: '',
			isDropDown: true,
		};
		dispatch(
			countryListAPI(
				data,
				res => {
					let countryData = [];
					if (res.data.data.countryList.length > 0)
						res.data.data.countryList.forEach(country => {
							countryData.push({
								key: country.countryName,
								value: country.countryCode
							});
						});
					setCountryList(countryData);
				},
				err => {
					toast.error(err?.data?.message || 'Error fetching countries', {
						theme: 'colored',
						autoClose: 10000
					});
					setCountryList([]);
				},
				headers
			)
		);
	};

	const getStates = async (selectCountryCode) => {
		const data = {
			countryCode: selectCountryCode,
			isDropDown: true,
			isList: false
		}
		await dispatch(stateListAPI(
			data,
			res => {

				let stateData = [];
				if (res && res.length > 0) {
					res.forEach(state => {
						stateData.push({
							key: state.stateName,
							value: state.stateCode
						});
					});
					setStateList(stateData);
				} else {
					setStateList([]);
				}
			},
			(err) => {
				setStateList([]);
			}
		));
	};

	const onPageClick = async ({ selected }) => {
		setPageNumber(selected + 1);
		fetchSubscriptionList(selected + 1)
	}

	const handlePageSize = async (e) => {
		setPageSize(e.target.value);
		setPageNumber(1);
		fetchSubscriptionList(1, e.target.value)
	}

	const handlePreviousClick = async () => {
		setPageNumber(pageNumber - 1);
		fetchSubscriptionList(pageNumber - 1)
	}

	const handleNextClick = async () => {
		setPageNumber(pageNumber + 1);
		fetchSubscriptionList(pageNumber + 1)
	}

	const handleFieldChange = (e) => {
		dispatch(
			customerDetailAction({
				...customerInquiryData,
				[e.target.name]: e.target.value,
			})
		);
		if (e.target.name == 'countryCode') {
			dispatch(
				customerDetailAction({
					...customerInquiryData,
					countryCode: e.target.value,
					stateCode: null
				})
			);
			setStateList([]);
			e.target.value && getStates(e.target.value);
		}
	};
	return (
		<>
			{/* {isLoading ? (
				<Spinner
				  className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
					animation="border"
				/>
			) : null} */}
			      {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}

			<Form className="details-form CaseScheduleDetailDashboard1" id="CaseScheduleDetailDashboard">
				{/* <Row className='justify-content-left ms-2 casSchedule-button '>
					<Form.Label column className='col-auto form-label-country-name'>
						Country
					</Form.Label>
					<Col className='col-auto client-list-filter case-list-filter'>
						<Form.Select id="txtCountry" name="countryCode"
							onChange={handleFieldChange}
							required>
							<option value=''>Select country</option>
							{countryList.map((option, index) => (
								<option key={index} value={option.value}>{option.key}</option>
							))}
						</Form.Select>
					</Col>
					<Form.Label column className='col-auto '>
						State
					</Form.Label>
					<Col className='col-auto client-list-filter case-list-filter state-list-drop'>
						<Form.Select id="txtState" name="stateCode" className='w-auto'
							onChange={handleFieldChange}
							required>
							<option value=''>Select state</option>
							{stateList.map((option, index) => (
								<option key={index} value={option.value}>{option.key}</option>
							))}
						</Form.Select>
					</Col>
					<Form.Label column className='col-auto'>
						Reg Type
					</Form.Label>
					<Col className='col-auto client-list-filter case-list-filter me-15'>
						<Form.Select id="regType" name="regType" className="w-auto report-dropdown" onChange={handleFieldChange} required>
							<option value=''>Select reg type</option>
							<option value="O">Approved Online</option>
							<option value="S">BySelf</option>
							<option value="P">Pending Online</option>
							<option value="M">Marketing Register</option>
							<option value="">All</option>
						</Form.Select>
					</Col>
					<Col className='col-auto client-list-filter case-list-filter '>
						<Button className="w-auto report-dropdown" onClick={() => fetchSubscriptionList()}>
							Search Record
						</Button>
					</Col>
					<Col className='col-auto '>
					{customerInquiryList.length > 0 &&
						<Button className='customer-list-pdf-button' onClick={() => GeneratePDFCustomerInquiry()}>
							Generate PDF Report
						</Button>
           }
					</Col>
				</Row> */}
				<Row className="g-2 align-items-center ms-2 casSchedule-button flex-wrap">
  <Form.Label column className="col-auto form-label-country-name">
    Country
  </Form.Label>
  <Col xs={12} md="auto" className="client-list-filter case-list-filter">
    <Form.Select
      id="txtCountry"
      name="countryCode"
      onChange={handleFieldChange}
      required
    >
      <option value="">Select country</option>
      {countryList.map((option, index) => (
        <option key={index} value={option.value}>
          {option.key}
        </option>
      ))}
    </Form.Select>
  </Col>

  <Form.Label column className="col-auto  state-Customer-inq">
    State
  </Form.Label>
  <Col xs={12} md="auto" className="client-list-filter case-list-filter state-list-drop">
    <Form.Select
      id="txtState"
      name="stateCode"
      className="w-auto"
      onChange={handleFieldChange}
      required
    >
      <option value="">Select state</option>
      {stateList.map((option, index) => (
        <option key={index} value={option.value}>
          {option.key}
        </option>
      ))}
    </Form.Select>
  </Col>

  <Form.Label column className="col-auto  state-Customer-inq">
    Reg Type
  </Form.Label>
  <Col xs={12} md="auto" className="client-list-filter case-list-filter ">
    <Form.Select
      id="regType"
      name="regType"
      className="w-auto report-dropdown"
      onChange={handleFieldChange}
      required
    >
      <option value="">Select reg type</option>
      <option value="O">Approved Online</option>
      <option value="S">BySelf</option>
      <option value="P">Pending Online</option>
      <option value="M">Marketing Register</option>
      <option value="">All</option>
    </Form.Select>
  </Col>

  <Col xs={12} md="auto" className="client-list-filter case-list-filter customer-inq-btn">
    <Button
      className="w-auto report-dropdown"
      onClick={() => fetchSubscriptionList()}
    >
      Search Record
    </Button>
  </Col>

  <Col xs={12} md="auto">
    {customerInquiryList.length > 0 && (
      <Button
        className="customer-list-pdf-button"
        onClick={() => GeneratePDFCustomerInquiry()}
      >
        Generate PDF Report
      </Button>
    )}
  </Col>
</Row>

				<div className="case-schedule-table-container">
					{customerInquiryList && customerInquiryList.length > 0 ?
						<Row className="no-padding">
							<Table striped bordered responsive className="table-md overflow-hidden case-schedule-table">
								<thead className='custom-bg-200 case-schedule-thead'>
									<tr>
										<th>S. No</th>
										<th>State Name</th>
										<th>Advocate Name</th>
										<th>Mobile No.</th>
										<th>Email Id</th>
										<th>Reg Type</th>
										<th>Total Amount</th>
									</tr>
								</thead>
								<tbody>
									{customerInquiryList.length > 0 && customerInquiryList.map(
										(data, index) => (
											<tr>
												<td>{index + 1}</td>
												<td>{data.stateName}</td>
												<td>{data.advocateName}</td>
												<td>{data.mobileNo}</td>
												<td>{data.email}</td>
												<td>{data.regType}</td>
												<td>{data.totalAmount ? data.totalAmount : "0"}</td>
											</tr>
										)
									)}
								</tbody>
							</Table>

						</Row>
						: <Row className='justify-content-center mt-2'>
							<Col className='col-auto'>
								<h4 id="no-subscription-message"></h4>
							</Col>
						</Row>
					}
				</div>
			</Form >
			<div className='customer-inq-pagination'>
			<Row  style={{ position: 'absolute', bottom: '30px', align: 'centre' }}>
				<TablePagination
			
					pageCount={pageCount}
					handlePageClick={onPageClick}
					pageSize={pageSize}
					handlePageSizeChange={handlePageSize}
					isDisablePrevious={isPreviousDisabled}
					isDisableNext={isNextDisabled}
					previousClick={handlePreviousClick}
					nextClick={handleNextClick}
					pageIndex={pageNumber - 1}
					module="CustomerInquiry"
				/>
			</Row>
			</div>
		</>
	)
}